// src/components/account-placement/account-placement.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment IconFragment on Icon {\n    __typename\n    id\n    token\n    description\n    theme\n    iconSize: size\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment ImageFragment on Image {\n    __typename\n    description\n    url\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  query CreditCardAccountPlacementQuery(\n    $context: ContextInput!\n    $variant: CreditCardAccountPlacementVariant!\n    $sourcePage: CreditCardAccountPlacementSourcePage!\n  ) {\n    creditCardAccountPlacement(context: $context, variant: $variant, sourcePage: $sourcePage) {\n      bottomLabel\n      cardImage {\n        ...ImageFragment\n      }\n      ctaAction {\n        accessibility\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        resource {\n          value\n        }\n        target\n      }\n      ctaIcon {\n        ...IconFragment\n      }\n      heading {\n        ...EGDSPlainTextFragment\n      }\n      impressionAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      subHeading\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
import React4 from "react";
import { gql as gql5, useQuery } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2 } from "@egds/react-core/images";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid } from "@egds/react-core/layout-grid";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/common/fragments/client-side-analytics.ts
import { gql } from "@apollo/client";
var ClientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var fragment = gql2(_templateObject1());
var EGDSPlainText = function (param) {
  var align = param.align,
    data = param.data,
    inline = param.inline,
    size = param.size,
    theme = param.theme,
    weight = param.weight;
  var text = data.text;
  return /* @__PURE__ */React.createElement(EGDSText, {
    align: align,
    size: size,
    inline: inline,
    theme: theme,
    weight: weight
  }, text);
};
EGDSPlainText.fragment = fragment;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/icon/icon.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var fragment2 = gql3(_templateObject2());
var Icon = function (param) {
  var data = param.data,
    size = param.size,
    isAriaHidden = param.isAriaHidden;
  var description = data.description,
    id = data.id,
    token = data.token,
    theme = data.theme;
  return id ? /* @__PURE__ */React2.createElement(EGDSIcon, {
    id: id,
    name: token,
    title: token,
    description: !isAriaHidden ? description : void 0,
    theme: theme !== null && theme !== void 0 ? theme : "default",
    size: size !== null && size !== void 0 ? size : EGDSIconSize.SMALL
  }) : null;
};
Icon.fragment = fragment2;
Icon.displayName = "Icon";
// ../internal/src/components/image/image.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSFigure, EGDSImage } from "@egds/react-core/images";
var fragment3 = gql4(_templateObject3());
var Image = function (param) {
  var data = param.data,
    imageFit = param.imageFit,
    ratio = param.ratio;
  var description = data.description,
    url = data.url;
  return /* @__PURE__ */React3.createElement(EGDSFigure, {
    ratio: ratio,
    imageFit: imageFit
  }, /* @__PURE__ */React3.createElement(EGDSImage, {
    alt: description,
    src: url
  }));
};
Image.fragment = fragment3;
Image.displayName = "Image";
// src/__generated__/types.ts
var CreditCardAccountPlacementSourcePage = /* @__PURE__ */function (CreditCardAccountPlacementSourcePage2) {
  CreditCardAccountPlacementSourcePage2["GLOBAL_NAV"] = "GLOBAL_NAV";
  CreditCardAccountPlacementSourcePage2["REWARDS"] = "REWARDS";
  CreditCardAccountPlacementSourcePage2["UNIVERSAL_PROFILE"] = "UNIVERSAL_PROFILE";
  return CreditCardAccountPlacementSourcePage2;
}(CreditCardAccountPlacementSourcePage || {});
var CreditCardAccountPlacementVariant = /* @__PURE__ */function (CreditCardAccountPlacementVariant2) {
  CreditCardAccountPlacementVariant2["MEDIUM"] = "MEDIUM";
  CreditCardAccountPlacementVariant2["SMALL"] = "SMALL";
  return CreditCardAccountPlacementVariant2;
}(CreditCardAccountPlacementVariant || {});
// src/components/account-placement/account-placement.tsx
var __Query = gql5(_templateObject4(), ClientSideAnalyticsFragment, EGDSPlainText.fragment, Icon.fragment, Image.fragment);
var smallAccountPlacementOptions = {
  headingSize: 8,
  imageWidth: 48,
  imageHeight: ["56px"],
  flexGap: "three"
};
var mediumAccountPlacementOptions = {
  headingSize: 5,
  imageWidth: 62,
  imageHeight: ["72px"],
  flexGap: "four"
};
var ChevronIcon = function (param) {
  var ctaIcon = param.ctaIcon;
  return /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem, {
    grow: 1,
    alignSelf: "center"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex, {
    justifyContent: "end"
  }, /* @__PURE__ */React4.createElement(Icon, {
    data: ctaIcon,
    size: EGDSIconSize2.MEDIUM,
    isAriaHidden: true
  })));
};
var AccountPlacement = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr;
  var _data;
  var context = useBexApi().context;
  var trackClick = useClickTracker();
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !((_data = data) === null || _data === void 0 ? void 0 : _data.creditCardAccountPlacement)) {
    return null;
  }
  var _data_creditCardAccountPlacement = data.creditCardAccountPlacement,
    bottomLabel = _data_creditCardAccountPlacement.bottomLabel,
    cardImage = _data_creditCardAccountPlacement.cardImage,
    ctaAction = _data_creditCardAccountPlacement.ctaAction,
    ctaIcon = _data_creditCardAccountPlacement.ctaIcon,
    heading = _data_creditCardAccountPlacement.heading,
    impressionAnalytics = _data_creditCardAccountPlacement.impressionAnalytics,
    subHeading = _data_creditCardAccountPlacement.subHeading;
  var accessibility = ctaAction.accessibility,
    clickAnalytics = ctaAction.analytics,
    resource = ctaAction.resource;
  var variantOptions = inputs.variant === "SMALL" /* SMALL */ ? smallAccountPlacementOptions : mediumAccountPlacementOptions;
  var onClickTracking = function () {
    trackClick(clickAnalytics.referrerId, clickAnalytics.linkName);
  };
  return /* @__PURE__ */React4.createElement(IntersectionTracker, {
    referrerId: impressionAnalytics.referrerId,
    linkName: impressionAnalytics.linkName
  }, /* @__PURE__ */React4.createElement(EGDSCard, {
    border: true
  }, /* @__PURE__ */React4.createElement(EGDSCardContentSection, {
    padded: true
  }, /* @__PURE__ */React4.createElement(EGDSSpacing, {
    padding: "one"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex, {
    space: variantOptions.flexGap
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem, {
    grow: 1,
    maxWidth: variantOptions.imageWidth
  }, /* @__PURE__ */React4.createElement(EGDSLayoutGrid, {
    autoRows: variantOptions.imageHeight
  }, /* @__PURE__ */React4.createElement(Image, {
    data: cardImage,
    imageFit: "contain",
    ratio: EGDSFigureAspectRatioType2.R1_1
  }))), /* @__PURE__ */React4.createElement(EGDSLayoutFlex, {
    direction: "column",
    justifyContent: "center"
  }, /* @__PURE__ */React4.createElement(EGDSHeading, {
    tag: "h3",
    size: variantOptions.headingSize
  }, heading.text), /* @__PURE__ */React4.createElement(EGDSSpacing, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React4.createElement(EGDSText2, {
    size: 200
  }, subHeading))), !bottomLabel && /* @__PURE__ */React4.createElement(ChevronIcon, {
    ctaIcon: ctaIcon
  })))), bottomLabel && /* @__PURE__ */React4.createElement(EGDSCardContentSection, {
    padded: true,
    border: "top"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex, {
    alignItems: "center"
  }, /* @__PURE__ */React4.createElement(EGDSHeading, {
    tag: "h4",
    size: 7
  }, bottomLabel), /* @__PURE__ */React4.createElement(ChevronIcon, {
    ctaIcon: ctaIcon
  }))), /* @__PURE__ */React4.createElement(EGDSCardLink, null, /* @__PURE__ */React4.createElement("a", {
    href: resource.value,
    onClick: onClickTracking,
    target: ctaAction.target === "EXTERNAL" ? "_blank" : void 0,
    rel: "noreferrer"
  }, accessibility))));
};
AccountPlacement.displayName = "sharedui-CreditCardAccountPlacement";
export { AccountPlacement, CreditCardAccountPlacementSourcePage, CreditCardAccountPlacementVariant };